import React, {useEffect, useState} from 'react';
import EditField from "@/views/Admin/Statistic/Member/EditField/EditField";

//Базовый компонент для поля в статистике заказа
const Member = (fieldId: string) => {
    const rootElement = document.getElementById(`region-field-suggest-${fieldId}`);
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        //Костыль для отслеживания изменения атрибута data-edit
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-edit') {
                    const newValue = rootElement.getAttribute('data-edit') === 'true';
                    setEdit(newValue);
                }
            });
        });

        observer.observe(rootElement, {
            attributes: true,
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div>
            {edit ? <EditField fieldId={Number(fieldId)} /> : null}
        </div>
    );
};

export default Member;
